import UserList from '@/components/users/UserList'
import UserVue from '@/components/users/UserVue'
import UserEdit from '@/components/users/UserEdit'
import UserCreate from '@/components/users/UserCreate'
import ChangePassword from '@/components/users/ChangePassword'
import UserContactList from '@/components/users/UserVuePanel/UserContactList'
import UserOptionsList from '@/components/users/UserVuePanel/UserOptionsList'
import UserPolesList from '@/components/users/UserVuePanel/UserPolesList'
import UserRdvsList from '@/components/users/UserVuePanel/UserRdvList'
import UserTeamList from '@/components/users/UserVuePanel/UserTeamList'
import UserSectorList from '@/components/users/UserVuePanel/UserSectorList'
import UserStatsPane from '@/components/users/UserVuePanel/UserStatsPane'
import UserSalesList from '@/components/users/UserVuePanel/UserSalesList'
import LinkedUsersList from '@/components/users/UserVuePanel/LinkedUsersList'

export default [
  {
    path: '/utilisateurs',
    name: 'UserList',
    component: UserList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'manager', 'manager_ext', 'operator', 'sector_manager']
    }
  },
  {
    path: '/utilisateurs/creation',
    name: 'UserCreate',
    component: UserCreate,
    meta: {
      parentName: 'UserList',
      requiresAuth: true,
      needProfile: ['admin', 'manager', 'manager_ext', 'operator', 'sector_manager']
    }
  },
  {
    path: '/utilisateurs/:id/edition',
    name: 'UserEdit',
    component: UserEdit,
    meta: {
      parentName: 'UserVue',
      requiresAuth: true
    }
  },
  {
    path: '/utilisateurs/:id/changement-mdp',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      parentName: 'UserVue',
      requiresAuth: true
    }
  },
  {
    path: '/utilisateurs/:id',
    name: 'UserVue',
    component: UserVue,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      maxHeight: true
    },
    props: true,
    children: [
      {
        path: 'equipe',
        name: 'UserTeam',
        component: UserTeamList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'secteur',
        name: 'UserSector',
        component: UserSectorList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'utilisateurs-associes',
        name: 'LinkedUsersList',
        component: LinkedUsersList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'contacts',
        name: 'UserContact',
        component: UserContactList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'options',
        name: 'UserOptions',
        component: UserOptionsList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'stats',
        name: 'UserStats',
        component: UserStatsPane,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'ventes',
        name: 'UserSales',
        component: UserSalesList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'rdvs',
        name: 'UserRdvs',
        component: UserRdvsList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      },
      {
        path: 'poles',
        name: 'UserPoles',
        component: UserPolesList,
        meta: {
          parentName: 'UserVue',
          requiresAuth: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/userRouter.js